import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import {
  AuctionService,
  CurrencyService,
  CategoryService,
  SaleTypeService,
  TimezoneService,
  LoaderService,
} from '../../../services';
import { ToastrService } from 'ngx-toastr';
import constants from '../../../utility/constants';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonDropdown, SaleType, Auction } from '../../../models';
import { AppValidators } from '../../../core/validators/app-validators';
import { GetAuctionStep1 } from '../../../models/auctionStep1';
import { Utils } from '../../../utility/utils';
import messages from '../../../utility/messages';
import { AuctionTimeService } from '../../../services/auction-time.service';
import { ImageValidators } from '../../../core/validators/image-validators';
import { BidIncrementService } from '../../bid-increment/services/bid-increment.service';
import {  Subscription } from 'rxjs';
import { Console } from 'console';
@Component({
  selector: 'app-add-auction-step1',
  templateUrl: './add-auction-step1.component.html',
  styleUrls: ['./add-auction-step1.component.css'],
  providers: [BidIncrementService],
})
export class AddAuctionStep1Component implements OnInit {
  //fieldLengths
  @Input('isEditMode') editMode: boolean;
  @Input('auctionId') auctionId: number;
  @Output('goToStep') step: EventEmitter<number> = new EventEmitter();
  @Output('newAuctionId') newAuctionId: EventEmitter<number> =
    new EventEmitter();
  @Output('newAuctionCode') newAuctionCode: EventEmitter<string> =
    new EventEmitter();
  @Output('getAuctionStatus') auctionStatus: EventEmitter<number> =
    new EventEmitter();
  @Output() otherStepsNeeded: EventEmitter<boolean> = new EventEmitter();

  fieldMaxLengthShort = constants.common.validations.maxLength30;
  fieldMaxLength = constants.common.validations.maxLength50;
  fieldMaxLength100 = constants.common.validations.maxLength100;
  fieldMaxLengthMedium = constants.common.validations.maxLength200;
  fieldMaxLengthLonger = constants.common.validations.maxLength1000;
  auctionStatuses = constants.common.auctionStatus;
  regFormats = constants.common.saletypeRegistrationFormat;
  currency = 1;
  returnUrl: string = '../'; // one step back
  disableStartTime: boolean = false;
  minDate: Date;
  stepActive = 1;
  showView: boolean = true;
  loading: boolean = false;
  createAuctionForm1: FormGroup;
  redirectLinkForm: FormGroup;
  saleManagers: Array<CommonDropdown>;
  currencies: Array<CommonDropdown>;
  categories: Array<CommonDropdown>;
  saletypes: Array<CommonDropdown>;
  timezones: Array<CommonDropdown>;
  bidIncrementTables: Array<CommonDropdown>;
  currentAuctionStatus: any;
  taglineText: string = null;
  isEditorCharLimitReached: boolean;

  disableEndTime: boolean = false;

  // check on submit button click
  isSubmitted: boolean = false;

  // selected saletype hint text
  saletypeHint: string;

  isItRedirectLink: boolean = false;
  showStaggerMinAndLotCloses: boolean = true;

  isBiddingAtOurPlatform: boolean = true;

  // settings for iamges
  coverPhotoSize: string = constants.admin.uploadSetting.coverPhotoMaxSize;
  coverPhotoFormat: string = constants.admin.uploadSetting.coverPhotoType;
  clientLogoSize: string = constants.admin.uploadSetting.clientLogoMaxSize;
  clientLogoFormat: string = constants.admin.uploadSetting.clientLogoType;

  // store image's URL
  coverPhotoString: string;
  clientLogoString: string;
  private subscriptions: Array<Subscription> = []; 
  disableStaggerTime: boolean;

  constructor(
    private currencyService: CurrencyService,
    private categoryService: CategoryService,
    private saletypeService: SaleTypeService,
    private auctionService: AuctionService,
    private timezoneService: TimezoneService,
    private toastr: ToastrService,
    private router: Router,
    private loaderService: LoaderService,
    private auctionTimeService: AuctionTimeService,
    private bidIncService: BidIncrementService
  ) {}

  ngOnInit() {
    this.initiateForm1();
    this.getEverthingForStep1();
  }

  private getEverthingForStep1() {
    this.getSaleManagers();
    this.getCurrencies();
    this.getCategories();
    this.getSaleTypes();
    this.getTimezones();
    if (this.auctionId > 0) {
      this.returnUrl = '../../';
      this.bindDataToForm1();
    } else {
      this.getIncrementTables();
    }
    
  }

  private getSaleManagers() {
    const salesmanagers = this.auctionService.getSaleManagers().subscribe((res) => {
      this.saleManagers = res;
    });
    this.subscriptions.push(salesmanagers);
  }

  private getCurrencies() {
    const currenciess = this.currencyService.getCurrency().subscribe((res) => {
      this.currencies = res;
    });
    this.subscriptions.push(currenciess);
  }

  private getTimezones() {
    const timezoness = this.timezoneService.getTimezone().subscribe((res) => {
      this.timezones = res;
    });
    this.subscriptions.push(timezoness);
  }

  private getCategories() {
    const cats = this.categoryService.categoryForDropDown().subscribe((res) => {
      this.categories = res;
    });
    this.subscriptions.push(cats);
  }

  private getSaleTypes() {
    const stypes = this.saletypeService.getSaletypeForDropDown().subscribe((res) => {
      this.saletypes = res;
    });
    this.subscriptions.push(stypes);
  }

  private getIncrementTables(status: number = 0) {
    this.bidIncService
      .getIncrementsInDD(status)
      .toPromise()
      .then((res) => {
        this.bidIncrementTables = res;
        if (!this.auctionId) {
          this.createAuctionForm1.patchValue({
            bidIncrementTableId: res[0].value,
          });
        }
      });
  }

  getSaletypeData() {
    let saleTypeId: number = this.createAuctionForm1.value.saletype;
    this.loaderService.showLoader(true);
    this.saletypeService
      .getSaleType(saleTypeId)
      .toPromise()
      .then((res) => {
        this.loaderService.showLoader(false);
        this.changesAccordingToSaletype(res);
      });
  }

removeValidation(event)
{
  let controls = this.createAuctionForm1.controls;
  let events = event.target.checked ;
  
 if(!events)
 {
  this.createAuctionForm1.get('lotClosesIn').disable()
  this.createAuctionForm1.get('minutesToExtend').disable()
  this.addRemoveValidatorAndValue(controls.lotClosesIn, false);
  this.createAuctionForm1.get('lotClosesIn').updateValueAndValidity(); 
  this.addRemoveValidatorAndValue(controls.minutesToExtend, false);
  this.createAuctionForm1.get('minutesToExtend').updateValueAndValidity(); 
 }
 else{
  this.createAuctionForm1.get('lotClosesIn').enable()
  this.createAuctionForm1.get('minutesToExtend').enable()
  this.addRemoveValidatorAndValue(
    controls.lotClosesIn,
    true,
    constants.admin.initialValues.lotClosesIn,
    [
      Validators.required,
      AppValidators.noWhitespace,
      AppValidators.onlyNumeric,
      Validators.maxLength(3),
    ]
  );
  this.addRemoveValidatorAndValue(
    controls.minutesToExtend,
    true,    
    constants.admin.initialValues.extendMinutes,
    [
      Validators.required,
      AppValidators.noWhitespace,
      AppValidators.onlyNumeric,
      Validators.maxLength(2),
    ]
  );
 }
}

  private changesAccordingToSaletype(saletype: SaleType) {
    let controls = this.createAuctionForm1.controls;

    this.isDetailPageInHouse(saletype.isDetailPageInHouse);

    if (
      saletype.isDetailPageInHouse &&
      saletype.registrationFormat === this.regFormats.tbgRegistration
    ) {
      this.showStaggerMinAndLotCloses = true;
      this.isBiddingAtOurPlatform = true;
      this.addRemoveValidatorAndValue(
        controls.bidIncrementTableId,
        true,
        controls.bidIncrementTableId.value,
        [Validators.required]
      );
      this.addRemoveValidatorAndValue(
        controls.staggerCompletionTime,
        true,
        controls.staggerCompletionTime.value,
        null
      );
      this.addRemoveValidatorAndValue(
        controls.lotClosesIn,
        true,
        controls.lotClosesIn.value,
        [
          Validators.required,
          AppValidators.noWhitespace,
          AppValidators.onlyNumeric,
          Validators.maxLength(3),
        ]
      );
      this.addRemoveValidatorAndValue(
        controls.minutesToExtend,
        true,
        controls.minutesToExtend.value,
        [
          Validators.required,
          AppValidators.noWhitespace,
          AppValidators.onlyNumeric,
          Validators.maxLength(2),
        ]
      );
    } else {
      this.showStaggerMinAndLotCloses = false;
      this.isBiddingAtOurPlatform = false;
      this.addRemoveValidatorAndValue(
        controls.bidIncrementTableId,
        false,
        null
      );
      this.addRemoveValidatorAndValue(controls.staggerCompletionTime, false);
      this.addRemoveValidatorAndValue(controls.lotClosesIn, false);
      this.addRemoveValidatorAndValue(controls.minutesToExtend, false);
    }
  }

  private initiateForm1() {
    this.createAuctionForm1 = new FormGroup(
      {
        title: new FormControl(null, [
          AppValidators.noWhitespace,
          Validators.required,
          Validators.maxLength(this.fieldMaxLength100),
        ]),
        byOrderOf: new FormControl(null, [
          AppValidators.noWhitespace,
          Validators.maxLength(this.fieldMaxLengthMedium),
        ]),
        tagline: new FormControl(null, [Validators.required]),
        auctionCode: new FormControl(
          null,
          [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(10),
            AppValidators.noWhitespace,
          ],
          this.checkAuctionCode.bind(this)
        ),
        saletype: new FormControl(null, Validators.required),
        bidIncrementTableId: new FormControl(null, Validators.required),
        auctionCategory: new FormControl(null, Validators.required),
        saleManager: new FormControl(null, Validators.required),
        currency: new FormControl(this.currency, Validators.required),
        startDate: new FormControl(null, Validators.required),
        startTime: new FormControl(
          constants.admin.initialValues.defaultStartTime,
          Validators.required
        ),
        endDate: new FormControl(null, Validators.required),
        endTime: new FormControl(
          constants.admin.initialValues.defaultEndTime,
          Validators.required
        ),
        timezone: new FormControl(null, Validators.required),
        staggerCompletionTime: new FormControl(true),
        lotClosesIn: new FormControl(
          constants.admin.initialValues.lotClosesIn,
          [
            Validators.required,
            AppValidators.noWhitespace,
            AppValidators.onlyNumeric,
            Validators.maxLength(3),
          ]
        ),
        minutesToExtend: new FormControl(
          constants.admin.initialValues.extendMinutes,
          [
            Validators.required,
            AppValidators.noWhitespace,
            AppValidators.onlyNumeric,
            Validators.maxLength(2),
          ]
        ),
        millisecondsAfterClose: new FormControl(
          constants.admin.initialValues.millisecondsAfterClose,
          [
            AppValidators.noWhitespace,
            AppValidators.onlyNumeric,
          ]
        ),
        redirectLink: new FormControl(null),
        coverPhoto: new FormControl(null),
        clientLogo: new FormControl(null),
      },
      this.checkEndDate.bind(this)
    );
  }

  private isDetailPageInHouse(isDetailPageInHouse: boolean) {
    let controls = this.createAuctionForm1.controls;
    if (isDetailPageInHouse) {
      this.isItRedirectLink = false;
      this.otherStepsNeeded.emit(true);
      this.addRemoveValidatorAndValue(controls.redirectLink, false);
      this.addRemoveValidatorAndValue(controls.coverPhoto, false);
      this.addRemoveValidatorAndValue(controls.clientLogo, false);
      this.clientLogoString = null;
      this.coverPhotoString = null;
    } else {
      this.isItRedirectLink = true;
      this.otherStepsNeeded.emit(false);
      this.addRemoveValidatorAndValue(
        controls.redirectLink,
        true,
        controls.redirectLink.value,
        [Validators.required, AppValidators.checkWebAddress]
      );
      this.addRemoveValidatorAndValue(
        controls.coverPhoto,
        true,
        controls.coverPhoto.value,
        [
          ImageValidators.sizeCheck(this.coverPhotoSize),
          ImageValidators.imageFormat(this.coverPhotoFormat),
          Validators.required,
        ]
      );
      this.addRemoveValidatorAndValue(
        controls.clientLogo,
        true,
        controls.clientLogo.value,
        [
          ImageValidators.sizeCheck(this.clientLogoSize),
          ImageValidators.imageFormat(this.clientLogoFormat),
          Validators.required,
        ]
      );
    }
  }

  private addRemoveValidatorAndValue(
    control: AbstractControl,
    isItAdd: boolean,
    value?: any,
    validArr?: ValidatorFn | ValidatorFn[]
  ) {
    if (isItAdd) {
      if (validArr) control.setValidators(validArr);
      control.patchValue(value);
    } else {
      control.clearValidators();
      control.patchValue(null);
    }
  }

  private bindDataToForm1() {
    this.loaderService.showLoader(true);
    this.showView = false;
    const getauction = this.auctionService.getAuctionStep1(this.auctionId).subscribe(
      (res: GetAuctionStep1) => {
        this.bindingForm(res);
        this.loaderService.showLoader(false);
        this.showView = true;
      },
      () => {
        this.gotoAuctionListing();
      }
    );
    this.subscriptions.push(getauction);
  }

  bindingForm(data: GetAuctionStep1) {
    this.changesAccordingToSaletype(data.saleType);

    this.getIncrementTables(data.auctionStatus);

    let sDate = data.startDate.split('-');
    let eDate = data.endDate.split('-');
    let start = new Date(
      parseInt(sDate[2]),
      parseInt(sDate[0]) - 1,
      parseInt(sDate[1])
    );
    let end = new Date(
      parseInt(eDate[2]),
      parseInt(eDate[0]) - 1,
      parseInt(eDate[1])
    );

    this.taglineText = data.tagline;
    this.clientLogoString = data.clientLogo;
    this.coverPhotoString = data.coverPhoto;

    this.currentAuctionStatus = data.auctionStatus;

    this.sendAuctionStatus(data.auctionStatus);
    this.sendNewlyCreatedAuctionCode(data.auctionCode);

    this.createAuctionForm1.patchValue({
      title: data.title,
      byOrderOf: data.byOrderOf,
      auctionCode: data.auctionCode,
      saletype: data.saleTypeId,
      auctionCategory: data.categoryId,
      saleManager: data.saleManagerId,
      currency: data.currencyId,
      startDate: start,
      startTime: data.startTime,
      endDate: end,
      endTime: data.endTime,
      tagline: data.tagline,
      timezone: data.timeZoneId,
      bidIncrementTableId: data.bidIncrementId,
      staggerCompletionTime: data.isStaggerAuctionEnable,
      lotClosesIn: data.staggerLotCloseTime,
      minutesToExtend: data.extendMinutes,
      millisecondsAfterClose: this.convertMillisecondsToHours(data.millisecondsAfterClose),
      redirectLink: data.detailPageLinkUrl,
      coverPhoto: data.coverPhoto,
      clientLogo: data.clientLogo,
    });

    if(!data.isStaggerAuctionEnable)
    {
      this.createAuctionForm1.get('lotClosesIn').disable()
      this.createAuctionForm1.get('minutesToExtend').disable()
     
    }
    else{
      this.createAuctionForm1.get('lotClosesIn').enable()
      this.createAuctionForm1.get('minutesToExtend').enable()
    }

    switch (data.auctionStatus) {
      case this.auctionStatuses.live:
        this.changesForLiveAuction(data);
        break;
      case this.auctionStatuses.past:
        this.changesForPastAuction(data);
        break;
    }
    
  }

  convertHoursToMilliseconds(hours: any) {
    // Calculate the equivalent milliseconds
    const milliseconds = Math.round(hours * 60 * 60 * 1000);
    return milliseconds;
  }

  convertMillisecondsToHours(millisceonds: any) {
    const hours = millisceonds / 3600000;
    return hours;
  }

  uploadCoverPhoto(files: FileList) {
    let reader = new FileReader();
    this.coverPhotoString = null;
    let control = this.createAuctionForm1.controls.coverPhoto;
    if (files.length > 0) {
      this.createAuctionForm1.patchValue({ coverPhoto: files[0] });
      control.markAsTouched();
      control.markAsDirty();
      control.updateValueAndValidity();
      if (control.valid) {
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          this.coverPhotoString = reader.result as string;
        };
      } else {
        this.coverPhotoString = null;
        control.markAsTouched();
      }
    }
  }

  uploadClientLogo(files: FileList) {
    let reader = new FileReader();
    this.clientLogoString = null;
    let control = this.createAuctionForm1.controls.clientLogo;
    if (files.length > 0) {
      this.createAuctionForm1.patchValue({ clientLogo: files[0] });
      control.markAsTouched();
      control.markAsDirty();
      control.updateValueAndValidity();
      if (control.valid) {
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          this.clientLogoString = reader.result as string;
        };
      } else {
        this.clientLogoString = null;
        control.markAsTouched();
      }
    }
  }

  private changesForLiveAuction(data: GetAuctionStep1) {
    this.createAuctionForm1.controls.auctionCode.disable();
    this.createAuctionForm1.controls.currency.disable();
    this.createAuctionForm1.controls.saletype.disable();
    this.createAuctionForm1.controls.timezone.disable();
    this.createAuctionForm1.controls.startDate.disable();
    this.createAuctionForm1.controls.startTime.disable();
    this.minDate = new Date(data.startDate);
    this.disableStartTime = true;
    this.disableEndTime = this.auctionTimeService.isLotClosingBegun(
      data.endDateTimeUtc
    );
    if (this.disableEndTime) this.createAuctionForm1.controls.endTime.disable();
    this.createAuctionForm1.controls.bidIncrementTableId.disable();
  }

  private changesForPastAuction(data: GetAuctionStep1) {
    this.createAuctionForm1.controls.auctionCode.disable();
    this.createAuctionForm1.controls.currency.disable();
    this.createAuctionForm1.controls.saletype.disable();
    this.createAuctionForm1.controls.timezone.disable();
    this.createAuctionForm1.controls.lotClosesIn.disable();
    this.createAuctionForm1.controls.minutesToExtend.disable();
    this.createAuctionForm1.controls.bidIncrementTableId.disable();
  }

  editorContent(
    event: { data: string; limitReached: boolean },
    control: AbstractControl
  ) {
    control.patchValue(event.data);
    control.markAsDirty();
    if (event.limitReached) control.setErrors({ invalid: true });
    else control.setErrors(null);
  }

  private createFormData() {
    let data = this.createAuctionForm1.getRawValue();
    let sDate = new Date(Utils.toLocalDateTime(data.startDate));
    let eDate = new Date(Utils.toLocalDateTime(data.endDate));
    return {
      id: this.auctionId,
      auctionCode: data.auctionCode,
      byOrderOf: data.byOrderOf,
      categoryId: data.auctionCategory,
      currencyId: data.currency,
      endDate: eDate,
      endTime: data.endTime,
      isStaggerAuctionInSecondsEnable: data.staggerCompletionTime,
      minuteToExtend: data.minutesToExtend,
      saleManagerId: data.saleManager,
      saleTypeId: data.saletype,
      staggerLotCloseTime: data.lotClosesIn,
      millisecondsAfterClose: this.convertHoursToMilliseconds(data.millisecondsAfterClose),
      startDate: sDate,
      startTime: data.startTime,
      tagline: data.tagline,
      timeZoneId: data.timezone,
      title: data.title,
      bidIncrementTableId: data.bidIncrementTableId,
    };
  }

  private createRedirectFormData() {
    let model = this.createFormData();

    let formValue = this.createAuctionForm1.value;
    let formData = new FormData();

    formData.append('id', '' + model.id);
    if (model.auctionCode)
      formData.append('auctionCode', '' + model.auctionCode);
    if (model.saleTypeId) formData.append('saleTypeId', '' + model.saleTypeId);
    if (model.title) formData.append('title', '' + model.title);
    if (model.byOrderOf) formData.append('byOrderOf', '' + model.byOrderOf);
    if (model.tagline) formData.append('tagLine', '' + model.tagline);
    if (model.categoryId) formData.append('categoryId', '' + model.categoryId);
    if (model.currencyId) formData.append('currencyId', '' + model.currencyId);
    if (model.saleManagerId)
      formData.append('saleManagerId', '' + model.saleManagerId);
    if (model.timeZoneId) formData.append('timeZoneId', '' + model.timeZoneId);
    if (model.startDate)
      formData.append('StartDate', model.startDate.toISOString());
    if (model.startTime) formData.append('StartTime', '' + model.startTime);
    if (model.endDate) formData.append('EndDate', model.endDate.toISOString());
    if (model.endTime) formData.append('EndTime', '' + model.endTime);

    if (formValue.coverPhoto){
      (typeof formValue.coverPhoto === "string") ?
      formData.append('coverPhoto', formValue.coverPhoto) :
      formData.append('coverPhoto', formValue.coverPhoto, formValue.coverPhoto?.name);
    }
    if (formValue.clientLogo){
      (typeof formValue.clientLogo === "string") ?
      formData.append('clientLogo', formValue.clientLogo) :
      formData.append('clientLogo', formValue.clientLogo, formValue.clientLogo?.name);
    }
    if (formValue.redirectLink)
      formData.append('detailPageLinkUrl', '' + formValue.redirectLink);

    return formData;
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.createAuctionForm1.invalid) {
      return;
    }

    if (this.createAuctionForm1.pristine) {
      this.toastr.success(
        this.editMode
          ? messages.addAuction1.updated
          : messages.addAuction1.saved,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
      this.goToStep();
      return;
    }

    this.loading = true;
    this.loaderService.showLoader(true);

    let model: any;
    let request: Observable<Auction>;

    if (this.isItRedirectLink) {
      model = this.createRedirectFormData();
      request = this.auctionService.addAuctionStepForRedirect(model);
    } else {
      model = this.createFormData();
      request = this.auctionService.addAuctionStep1(model);
    }

    const req = request.subscribe(
      (data) => {
        this.loading = false;
        this.loaderService.showLoader(false);
        this.toastr.success(
          this.editMode
            ? messages.addAuction1.updated
            : messages.addAuction1.saved,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.sendNewlyCreatedAuctionId(data.id);
        this.sendNewlyCreatedAuctionCode(data.auctionCode);
        this.goToStep();
      },
      (err) => {
        this.loading = false;
        this.loaderService.showLoader(false);
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    );
    this.subscriptions.push(req);
  }

  gotoAuctionListing() {
    if (this.currentAuctionStatus == 1) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'live' },
      });
    } else if (this.currentAuctionStatus == 2) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'upcoming' },
      });
    } else if (this.currentAuctionStatus == 4) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'recent' },
      });
    } else {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'pending' },
      });
    }
  }

  checkTitle(
    control: FormControl
  ): Observable<{ [key: string]: boolean } | null> {
    return this.auctionService
      .isTitleUniqueCheck(this.auctionId, control.value)
      .pipe(
        map((res) => {
          if (!control.touched) {
            return null;
          } else if (!res.data) {
            return { isTitleExists: true };
          }
          return null;
        })
      );
  }

  checkAuctionCode(
    control: FormControl
  ): Observable<{ [key: string]: boolean } | null> {
    return this.auctionService
      .isAuctionCodeUniqueCheck(this.auctionId, control.value)
      .pipe(
        map((res) => {
          if (!control.touched) {
            return null;
          } else if (res.data == false) {
            return { isAuctionCodeExists: true };
          }
          return null;
        })
      );
  }

  checkEndDate(controls: FormGroup): { [s: string]: boolean | null } {
    let values = controls.value;

    if (values.startDate != null && values.endDate != null) {
      let sDate = this.convertDateAndTimeToStamp(
        values.startDate,
        values.startTime
      );
      let eDate = this.convertDateAndTimeToStamp(
        values.endDate,
        values.endTime
      );

      if (eDate <= sDate) {
        return { invalidEndDate: true };
      }
      return null;
    }
    return null;
  }

  convertDateAndTimeToStamp(date: string, time: string): number {
    let dateObj = new Date(date);
    let [timeObj, meridian] = time.split(' ');
    let [hour, min] = timeObj.split(':');
    hour = (+hour === 12 ? 0 : +hour).toString();
    hour = (
      ['PM', 'pm', 'Pm', 'pM'].includes(meridian) ? +hour + 12 : +hour
    ).toString();
    return new Date(
      dateObj.getFullYear(),
      dateObj.getMonth(),
      dateObj.getDate(),
      +hour,
      +min
    ).getTime();
  }

  goToStep() {
    this.step.emit(this.isItRedirectLink ? 5 : 2);
  }

  sendNewlyCreatedAuctionId(id: number) {
    this.newAuctionId.emit(id);
  }

  sendNewlyCreatedAuctionCode(code: string) {
    this.newAuctionCode.emit(code);
  }

  sendAuctionStatus(status: number) {
    this.auctionStatus.emit(status);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
